import * as React from "react";
import type { SVGProps } from "react";
const SvgRetraceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="retrace_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M234.667 725.333a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm0-85.333a149.419 149.419 0 0 1 143.146 106.667H896A42.667 42.667 0 1 1 896 832H377.813a149.419 149.419 0 0 1-292.48-42.667A149.333 149.333 0 0 1 234.667 640zM85.333 576A42.667 42.667 0 0 1 128 533.333h768a42.667 42.667 0 1 1 0 85.334H128A42.667 42.667 0 0 1 85.333 576zm0-426.667A42.667 42.667 0 0 1 128 106.667h768A42.667 42.667 0 1 1 896 192H128a42.667 42.667 0 0 1-42.667-42.667zM128 320a42.667 42.667 0 1 0 0 85.333h390.187a149.419 149.419 0 0 0 286.293 0H896A42.667 42.667 0 1 0 896 320h-91.52a149.419 149.419 0 0 0-286.293 0H128zm597.333 42.667a64 64 0 1 1-128 0 64 64 0 0 1 128 0z"
    />
  </svg>
);
export default SvgRetraceIcon;
